module.exports = __WEBPACK_EXTERNAL_MODULE_99__;


//////////////////
// WEBPACK FOOTER
// external "maptalks"
// module id = 99
// module chunks = 0